import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Contest} from '../../model/contest/Contest';
import {NotificationHandler} from '../../helper/notification.handler';
import {ContestService} from '../../service/contest.service';

@Component({
  selector: 'contest-select-panel',
  templateUrl: './contest-select-panel.component.html',
  styleUrls: ['./contest-select-panel.component.scss']
})
export class ContestSelectPanelComponent implements OnInit {

  @Input() competitionId?: string;
  @Input() contest?: Contest | null;
  @Input() mobileView = false;

  @Input() additionalCta?: string;
  @Input() additionalCtaShow = false;
  @Input() additionalCtaWidth = 'auto';
  @Input() additionalCtaDisabled = false;

  @Input() showDetails = true;

  today!: Date;
  contestLoading = false;

  @Output() selected = new EventEmitter<Contest>();
  @Output() openForEnrolUpdated = new EventEmitter<boolean>();
  @Output() additionalCtaClicked = new EventEmitter<Contest>();

  constructor(private contestService: ContestService) {
  }

  ngOnInit(): void {
    this.today = new Date();
  }

  contestSelected(contest: Contest) {
    this.contest = contest;

    if (this.showDetails) {
      this.contest = null;
      this.contestLoading = true;

      this.openForEnrolUpdated.emit(false);
      this.contestService.getDetails(contest.id).subscribe(c => {
        this.contest = c;
        this.today = new Date();

        if (this.contest.enrolStartsAt && this.contest.enrolStartsAt < this.today && this.contest.enrolEndsAt && this.contest.enrolEndsAt > this.today && this.contest.endsAt && this.contest.endsAt > this.today) {
          this.openForEnrolUpdated.emit(true);
        }
        this.contestLoading = false;

        this.selected.emit(this.contest);
      }, error => {
        NotificationHandler.handleError($localize`:Notifications|Contest details fetch has failed message@@notifications-contest-details-fetch-failed-error:Contest details fetch has failed`, error);
      });
    } else {
      this.selected.emit(this.contest);
    }
  }
}
